import { supabase } from "../supabase";

export const DAYS = ["monday","tuesday","wednesday","thursday","friday","saturday","sunday"];
export const DAY_LABELS = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
export const formatTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, "0")}${h < 12 ? "a" : "p"}`;
};

export const US_STATES = [
  { code: "AL", name: "Alabama" }, { code: "AK", name: "Alaska" }, { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" }, { code: "CA", name: "California" }, { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" }, { code: "DE", name: "Delaware" }, { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" }, { code: "HI", name: "Hawaii" }, { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" }, { code: "IN", name: "Indiana" }, { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" }, { code: "KY", name: "Kentucky" }, { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" }, { code: "MD", name: "Maryland" }, { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" }, { code: "MN", name: "Minnesota" }, { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" }, { code: "MT", name: "Montana" }, { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" }, { code: "NH", name: "New Hampshire" }, { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" }, { code: "NY", name: "New York" }, { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" }, { code: "OH", name: "Ohio" }, { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" }, { code: "PA", name: "Pennsylvania" }, { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" }, { code: "SD", name: "South Dakota" }, { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" }, { code: "UT", name: "Utah" }, { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" }, { code: "WA", name: "Washington" }, { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" }, { code: "WY", name: "Wyoming" },
  { code: "DC", name: "District of Columbia" }, { code: "PR", name: "Puerto Rico" },
  { code: "GU", name: "Guam" }, { code: "VI", name: "U.S. Virgin Islands" },
  { code: "AS", name: "American Samoa" }, { code: "MP", name: "Northern Mariana Islands" },
];

export const getPrimaryImage = (p) => (p?.images?.length > 0 ? p.images[0] : p?.image) ?? "";

export const validateCoupon = (coupon, subtotal) => {
  if (!coupon || !coupon.active) return { valid: false, reason: "Invalid coupon code." };
  if (coupon.expires_at && new Date(coupon.expires_at) < new Date()) return { valid: false, reason: "This coupon has expired." };
  if (coupon.usage_limit != null && coupon.usage_count >= coupon.usage_limit) return { valid: false, reason: "This coupon has reached its usage limit." };
  if (coupon.min_subtotal && subtotal < coupon.min_subtotal) return { valid: false, reason: `Minimum order of $${Number(coupon.min_subtotal).toFixed(2)} required.` };
  return { valid: true };
};

// FALLBACK ONLY — profiles are now auto-created by a Postgres trigger on
// auth.users INSERT (handle_new_user) and auto-activated on email confirmation
// (handle_user_email_confirmed). This function exists as a safety net for any
// edge case where the trigger doesn't fire (e.g. restored backups, manual
// auth.users inserts). See migration 20260403_001_auto_profile_triggers.sql.
export const ensureProfile = async (authUser) => {
  let { data: profile } = await supabase
    .from("profiles")
    .select("*")
    .eq("id", authUser.id)
    .single();
  if (!profile) {
    // Trigger should have created this — log for monitoring
    console.warn(`[ensureProfile] fallback: creating missing profile for ${authUser.id}`);
    const meta = authUser.user_metadata || {};
    profile = {
      id: authUser.id,
      name: meta.name || authUser.email.split("@")[0],
      email: authUser.email,
      is_admin: false,
      marketing_opt_in: !!meta.marketing_opt_in,
      status: meta.approval_status || "active",
    };
    await supabase.from("profiles").insert(profile);
  }
  return profile;
};
